/* See rl-dive-flip.css. Phones only (749px and under, the same breakpoint the
   dive section uses). One passive scroll listener, throttled to a frame. */
(function(){
  function init(){
    var col = document.querySelector('.rl-dive__col--right');
    if(!col) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var queued = false;
    function check(){
      queued = false;
      if(!mq.matches){ col.classList.remove('rl-under'); return; }
      var r = col.getBoundingClientRect();
      var mid = r.top + r.height / 2;
      col.classList.toggle('rl-under', mid < window.innerHeight * 0.5);
    }
    function queue(){ if(!queued){ queued = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', queue, {passive:true});
    window.addEventListener('resize', queue);
    check();
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
